import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { withNamespaces, Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import { routerStore, Link } from 'core/routing';
import { inWhitelabel } from 'core/whitelabel';

import { Div } from 'legacyComponents/styled/lib';
import { media } from 'legacyComponents/styled/styleUtils';
import { CardIndicator } from 'legacyComponents/cards/types/indicator';
import {
  SmallCard,
  SmallCardTextWrapper,
  FullWidthTitle as Title,
  FullWidthDescription as Description,
} from 'legacyComponents/cards/styles';
import { Icon } from 'components';

import { clientStore } from 'apps/client/app';

export const CategoryCard = withNamespaces()(
  observer(({ cardObject, cardNo, cardColumns }) => {
    const noMargin = (cardNo + 1) % cardColumns === 0;
    if (cardObject === null) {
      return <CardIndicator noMargin={noMargin} type='issue' />;
    }

    const {
      title,
      color,
      threadsCount,
      privateThreadsCount,
      urlId,
    } = cardObject;
    const categoryRoute = 'initiative.forum.category';
    let categoryParams = Object.assign({}, clientStore.spaceParams, {
      categoryId: urlId,
    });
    if (!routerStore.route.name.includes('initiative') && inWhitelabel) {
      categoryParams = Object.assign(
        {},
        {
          initiative: `+${cardObject.manager.forum.parentContent.whitelabel}`,
          categoryId: urlId,
        },
      );
    }

    let displayCount = (
      <Trans count={threadsCount}>{{ threadsCount }} threads</Trans>
    );
    if (privateThreadsCount !== threadsCount) {
      if (threadsCount > 0) {
        displayCount = (
          <Trans count={privateThreadsCount}>
            {{ threadsCount }} public, {{ privateThreadsCount }} private threads
          </Trans>
        );
      } else {
        displayCount = (
          <Trans count={privateThreadsCount}>
            {{ privateThreadsCount }} private threads
          </Trans>
        );
      }
    }

    return (
      <Card noMargin={noMargin}>
        <Div position='relative' display='block'>
          <ColorIndicator color={color === null ? '#cdcdcd' : `#${color}`}>
            <Icon name='categories' title={title} />
          </ColorIndicator>
        </Div>
        <TextWrapper>
          <Link
            name={categoryRoute}
            params={categoryParams}
            content={cardObject.manager.forum.parentContent}
          >
            <Title>{title || 'Untitled Category'}</Title>
          </Link>
          <Description>{displayCount}</Description>
        </TextWrapper>
      </Card>
    );
  }),
);

const Card = styled(SmallCard)`
  &:hover {
    a > h3 {
      color: ${props => props.theme.color.primary};
    }
  }
`;

const TextWrapper = styled(SmallCardTextWrapper)`
  margin-left: 50px;
  margin-right: 0px;
`;

const ColorIndicator = styled.div`
  width: 38px;
  height: 38px;
  position: absolute;
  top: 0;
  background-color: ${props => props.color};
  border-radius: 50%;
  color: ${props => props.theme.color.wfWhite};
  text-align: center;
  line-height: 35px;
  ${media.s`
    width: 36px;
    height: 36px;
  `};
`;

CategoryCard.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  author: PropTypes.string,
  datePublished: PropTypes.string,
  comments: PropTypes.array,
};
